import React from 'react';
import { CheckCircleIcon, DownloadIcon, MailIcon, RefreshCwIcon } from 'lucide-react';
interface ConfirmationPageProps {
  onReset?: () => void;
}
const ConfirmationPage: React.FC<ConfirmationPageProps> = ({
  onReset
}) => {
  return <div className="min-h-screen bg-slate-50 py-12" data-id="element-9" data-mp="3vmqqdi464d6y">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-10" data-mp="3qnx8ldhum00z">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12 text-center" data-id="element-11" data-mp="3qpryl67z8ibx">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-12" data-mp="s502j9wz7kr4">
            <CheckCircleIcon size={40} className="text-green-600" data-id="element-13" data-mp="n8rs29tq4fqa" />
          </div>
          <h1 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-14" data-mp="ie5imc77cx8u">Thank You!</h1>
          <p className="text-lg text-slate-700 mb-8" data-id="element-15" data-mp="dg3yrp1yctwb">
            Your Will and Power of Attorney intake form has been successfully
            submitted.
          </p>
          <div className="bg-slate-50 p-6 rounded-lg mb-8 text-left" data-id="element-16" data-mp="165164x4ml6aa">
            <h2 className="text-xl font-semibold text-navy-900 mb-4" data-id="element-17" data-mp="163q0errmdogj">
              What Happens Next?
            </h2>
            <ul className="space-y-3" data-id="element-18" data-mp="x791jj2gbrjf">
              <li className="flex" data-id="element-19" data-mp="x67gqmvmvqoi">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-20" data-mp="x9botvc7z6kg">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-21" data-mp="nh5z6s9fx18f">1</span>
                </div>
                <p className="text-slate-700" data-id="element-22" data-mp="9hertadfij3e">
                  Our legal team will review your information within 1-2
                  business days.
                </p>
              </li>
              <li className="flex" data-id="element-23" data-mp="3vped6f5gqf4l">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-24" data-mp="3vqfz5eo0om13">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-25" data-mp="4kxr7gp1mc9f">2</span>
                </div>
                <p className="text-slate-700" data-id="element-26" data-mp="1tvot1kp4gaz6">
                  You'll receive an email confirmation with a copy of your
                  responses.
                </p>
              </li>
              <li className="flex" data-id="element-27" data-mp="1xh0d8b3uxnku">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-28" data-mp="1sgm6cwdzsjoe">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-29" data-mp="1ngq0sspnck6q">3</span>
                </div>
                <p className="text-slate-700" data-id="element-30" data-mp="1ij81lu1fljbx">
                  A lawyer will contact you to schedule a consultation or
                  request additional information if needed.
                </p>
              </li>
            </ul>
          </div>

          {onReset && <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-31" data-mp="26g3ynlqhyf2i">
              <p className="text-sm text-slate-500 mb-3" data-id="element-32" data-mp="26eap9yoi1gqt">
                Need to submit another intake form?
              </p>
              <button onClick={onReset} className="flex items-center justify-center mx-auto px-6 py-3 bg-slate-100 text-slate-700 rounded-md hover:bg-slate-200 transition-colors font-medium" data-id="element-33" data-mp="2ywem7fn95b5f">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-34" data-mp="32fx93hd9lfvr" />
                Start a New Form
              </button>
            </div>}
          <p className="mt-8 text-sm text-slate-500" data-id="element-35" data-mp="36i0ky73uimhk">
            Reference #: WPA-{Math.floor(100000 + Math.random() * 900000)}
          </p>
        </div>
        <div className="mt-8 text-center" data-id="element-36" data-mp="3gf6ern3ugrlh">
          <p className="text-slate-600" data-id="element-37" data-mp="3gc0qub6ybvrc">
            If you have any questions, please contact us at:
          </p>
          <p className="font-medium text-navy-700 mt-1" data-id="element-38" data-mp="3petiifk1q9hp">
            (555) 123-4567 or support@lawfirmname.com
          </p>
        </div>
      </div>
    </div>;
};
export default ConfirmationPage;